import React, { useState } from "react";
import { Form, Input, Row, Col, Button } from "antd";
import BarcodeScannerComponent from "react-qr-barcode-scanner";

const StockValidationForm = ({
  modalForm,
  handleManualInputChange,
  setScannerActive,
  StockData,
  scannerActive,
  handleScanBarcode,
}) => {
  const [expectedQuantity, setExpectedQuantity] = useState("");
  const [isChecked, setIsChecked] = useState(false); // Control quantity input state

  // Handle Barcode Check
  const handleCheckBarcode = async () => {
    try {
      const values = await modalForm.validateFields(["barcode"]); // Get barcode input value
      const barcodeValue = values.barcode.trim(); // Ensure no accidental spaces

      if (!barcodeValue) {
        return;
      }

      const foundItem = StockData.find((item) => item.barcode === barcodeValue);

      if (foundItem) {
        setExpectedQuantity(foundItem.quantity); // ✅ Set expected quantity from stock
        setIsChecked(true); // Enable quantity input
      } else {
        setExpectedQuantity("Not found");
        setIsChecked(false);
      }
    } catch (error) {
      console.error("Error validating barcode:", error);
    }
  };

  return (
    <Form form={modalForm} layout="vertical">
      {/* Barcode Input with Scan */}
      <Form.Item
        label="Barcode"
        name="barcode"
        rules={[{ required: true, message: "Please input Barcode!" }]}
      >
        <div style={{ display: "flex", alignItems: "center" }}>
          <Input
            onChange={handleManualInputChange} // Handle manual input change
            style={{ marginRight: "10px" }}
          />
          <Button
            onClick={() => setScannerActive(true)}
            disabled={scannerActive}
          >
            Scan
          </Button>
        </div>
        {scannerActive && (
          <div style={{ marginTop: "10px" }}>
            <BarcodeScannerComponent
              width={400}
              height={400}
              onUpdate={handleScanBarcode} // Handle barcode scan
            />
            <Button
              onClick={() => setScannerActive(false)}
              style={{ marginTop: "10px" }}
            >
              Close Scanner
            </Button>
          </div>
        )}
      </Form.Item>

      {/* Check Button */}
      <Button
        type="primary"
        onClick={handleCheckBarcode}
        style={{ marginBottom: "10px" }}
      >
        Check
      </Button>

      {/* Quantity and Expected Quantity */}
      <Row gutter={16}>
        <Col span={12}>
          <Form.Item
            label="Current Quantity"
            name="currentQuantity"
            rules={[{ required: true, message: "Please input Quantity!" }]}
          >
            <Input
              name="currentQuantity" // ✅ Ensure input name is set correctly
              onChange={handleManualInputChange} // ✅ Handle changes dynamically
              disabled={!isChecked}
            />
          </Form.Item>
        </Col>
        <Col span={12}>
          <Form.Item label="Expected Quantity">
            <Input disabled value={expectedQuantity} />
          </Form.Item>
        </Col>
      </Row>

      <Form.Item
        label="Keterangan"
        name="keterangan"
        onChange={handleManualInputChange} // ✅ Handle changes dynamically
        rules={[{ message: "Please input Keterangan!" }]}
      >
        <Input />
      </Form.Item>
    </Form>
  );
};

export default StockValidationForm;
